import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Components
import { Fab } from 'app/components/Mui';
// Hooks
import useToggle from 'app/hooks/useToggle';
import useAccountStatus from 'app/hooks/useAccountStatus';
//
import TeamFormDialog from './TeamFormDialog';

const TeamsFab:FC = () => {
  const { t } = useTranslation();

  const { isSuspended } = useAccountStatus();
  const { open, toggle } = useToggle();
  return (
    <Fragment>
      <Fab
        name="Create team"
        sx={{
          position: 'fixed',
          right: 16,
          bottom: 16
        }}
        onClick={toggle}
        color="primary"
        variant="extended"
        disabled={isSuspended}
      >{t('pages.teams.createButton')}</Fab>
      {/* Dialog */}
      {open ? (
        <TeamFormDialog
          open={open}
          onClose={toggle}
        />
      ) : null}
    </Fragment>
  )
}

export default TeamsFab;
